import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Path } from '@antv/g';
import { ScaleInY } from './scaleInY';
/**
 * Scale mark from nothing to desired shape in x direction.
 */
export var GrowInY = function GrowInY(options, context) {
  return function (from, to, defaults) {
    var _from = _slicedToArray(from, 1),
      shape = _from[0];
    var _shape$getBoundingCli = shape.getBoundingClientRect(),
      height = _shape$getBoundingCli.height,
      width = _shape$getBoundingCli.width;
    var clipPath = new Path({
      style: {
        path: "M0,0L".concat(width, ",0L").concat(width, ",").concat(height, "L0,").concat(height, "Z")
      }
    });
    shape.appendChild(clipPath);
    shape.style.clipPath = clipPath;
    var animation = ScaleInY(options, context)([clipPath], to, defaults);
    animation.finished.then(function () {
      clipPath.remove();
      shape.style.clipPath = null;
    });
    return animation;
  };
};
GrowInY.props = {};